import { ContentfulAsset } from '../../Contentful';
import { ModuleType } from '../types';
import { isValidGridItem } from './validation';

export type HeroData = {
  title?: string;
  url?: string;
  image?: ContentfulAsset;
};

// Type guards for runtime checking
function isArticlePage(item: any): boolean {
  return item?.contentType === 'articlePage';
}

function isVideoPage(item: any): boolean {
  return item?.contentType === 'videoPage';
}

// Simple function to extract hero data from articleLink
export function getHeroData(
  articleLink?: ModuleType,
  locale: string = 'en',
): HeroData | null {
  // Handle undefined case first
  if (!articleLink) {
    return null;
  }

  // Use the same validation as grid items
  if (!isValidGridItem(articleLink, locale)) {
    return null;
  }

  const item = articleLink as any;

  // Use type narrowing based on content type
  if (isArticlePage(item)) {
    return {
      title: item.title?.trim(),
      url: `/blog/${item.urlSlug}`,
      image: item.headerModule?.image,
    };
  }

  if (isVideoPage(item)) {
    return {
      title: item.title?.trim(),
      url: `/video/${item.urlSlug}`,
      image: item.thumbnailImage,
    };
  }

  // Unsupported content type
  return null;
}
